import serverCall from "../../serverCall";

const create4DMultiImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/multifourd-image`, data
    );
    return response;
};

const newCreate4DMultiImage = async (data) => {
    const response = await serverCall.post(
        `/images/admin/v2/multifourd-image`, data
    );
    return response;
};

const GetAll4DMultImages = async (id) => {
    const response = await serverCall.get(`/category/admin/all-category`);
    return response;
};

const Delete4DMulti = async (id) => {
    const response = await serverCall.delete(`/category/admin/${id}`);
    return response;
};

const Multi4DImageService = {
    create4DMultiImage,
    GetAll4DMultImages,
    Delete4DMulti,
    newCreate4DMultiImage
};

export default Multi4DImageService;
